import { concent } from "./gtag/concent";
import { config, get, set } from "./gtag/config";
import { event } from "./gtag/event";

/**
 * アナリティクス
 * https://developers.google.com/analytics/devguides/collection/ga4/reference/config?hl=ja
 * https://developers.google.com/analytics/devguides/collection/ga4/reference/events?hl=ja&client_type=gtag
 * 手動でpage_viewの送り方
 * https://developers.google.com/analytics/devguides/collection/ga4/views?hl=ja&client_type=gtag
 * なぜかga4のリファレンスにはpage_view,exception,view_search_resultsの送り方が書いてないので以下を参照
 * https://developers.google.com/tag-platform/gtagjs/reference/events?hl=ja
 */
declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (tagName:TagName,...rest:unknown[]) => void;
  }
}
/**
 * 
 */
export type TagName = 'config' | 'js' | 'set' | 'event' | 'get' | 'concent';
/**
 * 
 */
export const gtag = new class Gtag {
    readonly config = config;
    readonly set = set;
    readonly get = get;
    readonly event = event;
    readonly concent = concent;
}
